import { useState, useEffect, Fragment } from 'react';
import { useSelector } from 'react-redux';
import { selectEmployees } from '../../views/employees/reducer';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { FaAngleDown } from 'react-icons/fa6';
interface EmployeeInitialsProps {
  employee: string;
}

export const EmployeeInitials = ({ employee }: EmployeeInitialsProps) => {
  const getEmployeeInitials = () => {
    if (!employee || employee === '--' || employee === 'All' || employee.trim() === '') {
      return '-';
    }
    let initials = '';
    const initialCount = 2;
    const words = employee.split(' ');
    if (words.length > 1) {
      for (let i = 0; i < initialCount; i++) {
        if (words[i].length > 0) {
          initials += words[i][0];
        }
      }
    } else {
      initials = employee.slice(0, 2);
    }
    return initials.toUpperCase();
  };
  return (
    <div className="employee-initials">
      <span>{getEmployeeInitials()}</span>
    </div>
  );
};

interface employeeInitialsDropdownProps {
  selectedEmployee: number | null;
  selectable?: boolean;
  onEmployeeSelect?: any;
  listHeight?: number;
}

export const EmployeeInitialsDropdown = ({
  selectedEmployee,
  selectable = true,
  onEmployeeSelect,
  listHeight = 150,
}: employeeInitialsDropdownProps) => {
  const employees = useSelector(selectEmployees);
  const [employeesOpen, setEmployeesOpen] = useState(false);
  const [employeeName, setEmployeeName] = useState('--');

  const handleEmployeeSelect = (id: number) => {
    if (selectable && onEmployeeSelect) onEmployeeSelect(id);
  };

  const filterCurrent = () => {
    return employees.filter((employee: any) => employee.id !== selectedEmployee);
  };

  useEffect(() => {
    const employee = employees.find((e: any) => e.id === Number(selectedEmployee));
    setEmployeeName(employee ? `${employee.firstName} ${employee.lastName}` : '');
  }, [selectedEmployee, employees]);

  return (
    <span className="employee-initials-dropdown">
      {selectable && employees && (
        <Dropdown
          isOpen={employeesOpen}
          toggle={() => setEmployeesOpen(!employeesOpen)}
          onClick={(e: any) => e.stopPropagation()}
          className="employee-dropdown"
        >
          <DropdownToggle className="employee-dropdown-toggle">
            <EmployeeInitials employee={employeeName} />
          </DropdownToggle>
          <DropdownMenu
            className="dropdown-menu-right"
            right
            style={{ maxHeight: listHeight ? `${listHeight}px` : '300px', overflowY: 'auto' }}
          >
            {filterCurrent().map((employee: any, i: number) => (
              <Fragment key={employee.id}>
                {i !== 0 && <DropdownItem divider />}
                <DropdownItem
                  onClick={() => handleEmployeeSelect(employee.id)}
                >{`${employee.firstName} ${employee.lastName}`}</DropdownItem>
              </Fragment>
            ))}
          </DropdownMenu>
        </Dropdown>
      )}
      {!selectable && employees && <EmployeeInitials employee={employeeName} />}
    </span>
  );
};
